<template>
	<div class="modern-slider-container" v-if="!(hideIfEmpty && sliders.length == 0)">
		<v-carousel
			:hide-delimiters="hideDelimiters"
			:show-arrows="showArrows && sliders.length > 1"
			cycle
			:height="height"
			show-arrows-on-hover
			class="modern-carousel"
		>
			<v-carousel-item v-for="slider in sliders" :key="slider.id" :src="slider.image_url" :contain="contain">
				<div class="slider-overlay-content pa-8" v-if="slider.name || slider.text || slider.url">
					<h1
						v-if="slider.name"
						class="slider-title font-weight-bold mb-2"
						v-text="slider.name"
						:style="{ color: slider.color || '#0f172a' }"
					></h1>
					<h3
						v-if="slider.text"
						class="slider-subtitle font-weight-regular mb-4"
						v-text="slider.text"
						:style="{ color: slider.color || '#334155' }"
					></h3>
					<v-btn
						v-if="slider.url"
						color="primary"
						depressed
						rounded
						large
						class="text-capitalize px-6 slider-cta-btn"
						:href="slider.url.replace('/#/', api.url.replace('public/', 'store/#/'))"
					>
						{{ "view_resource" | trans }}
						<v-icon right small>mdi-arrow-right</v-icon>
					</v-btn>
				</div>
			</v-carousel-item>
		</v-carousel>
	</div>
</template>

<script>
export default {
	name: "Sliders",
	async mounted() {
		await this.api.ready;
		this.sliders = (await this.api.get("sliders")).data;
	},
	data() {
		return {
			sliders: [],
		};
	},
	props: {
		hideIfEmpty: {
			type: Boolean,
			default: true,
		},
		hideDelimiters: {
			type: Boolean,
			default: true,
		},
		showArrows: {
			type: Boolean,
			default: true,
		},
		height: {
			type: [Number, String],
		},
		contain: {
			default: true,
		},
	},
};
</script>

<style scoped>
.modern-slider-container {
	position: relative;
	background-color: #ffffff;
	border-bottom: 1px solid #eef2f6;
}

.modern-carousel {
	background-color: #ffffff;
}

.slider-overlay-content {
	position: absolute;
	top: 20%;
	left: 5%;
	max-width: 550px;
	z-index: 2;
	background: rgba(255, 255, 255, 0.85);
	backdrop-filter: blur(8px);
	border-radius: 16px;
	border: 1px solid rgba(255, 255, 255, 0.4);
	box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05);
}

.slider-title {
	font-size: 2rem;
	line-height: 1.2;
}

.slider-subtitle {
	font-size: 1.1rem;
	line-height: 1.4;
}

.slider-cta-btn {
	font-weight: 600;
	letter-spacing: 0;
}

@media (max-width: 600px) {
	.slider-overlay-content {
		top: 10%;
		left: 4%;
		right: 4%;
		max-width: 100%;
		padding: 16px !important;
	}

	.slider-title {
		font-size: 1.3rem;
	}

	.slider-subtitle {
		font-size: 0.9rem;
	}
}
</style>
